/**
 * TeamMatchupImage Component
 */

import React, { FC } from 'react';
import { TeamMatchupImageProps, GetSrcProps } from './teamMatchupImage.types';
import Image from '../Image/image';

export const getSrc = ({
  away,
  home,
  ratio,
  width,
}: GetSrcProps) => `https://midfield.mlbstatic.com/v1/teams-matchup/${away}-${home}/ar_${ratio}/w_${width}`;

const TeamMatchupImage: FC<TeamMatchupImageProps> = ({
  awayTeamId,
  homeTeamId,
  ratio,
  srcsetWidth,
  srcWidth,
  ...props
}) => {

  const src = getSrc({
    away: awayTeamId,
    home: homeTeamId,
    ratio,
    width: srcWidth,
  });
  let srcset;
  if(srcsetWidth){
    srcset = Object.keys(srcsetWidth).reduce((result, key) => {
      result[key] = getSrc({
        away: awayTeamId,
        home: homeTeamId,
        ratio,
        width: srcsetWidth[key],
      });
      return result;
    }, {});
  }
  return (
    <Image
      src={src}
      srcset={srcset}
      ratio={ratio}
      {...props}
    />
  );
};

export default TeamMatchupImage;
